module.exports = __webpack_public_path__ + "static/media/icon-signout.4efe7c24.svg";